/**
 * @override
 * Override standard fragment to include blogContent field with links.
 * Links are needed to render embedded entries/assets in rich text.
 */

import gql from 'graphql-tag';

import {BaseBlogFragment} from '@amblique/contentful/app/contentful/fragments/blog/base-blog.fragment';
import {BaseImageFragment} from '@amblique/contentful/app/contentful/fragments/image/base-image.fragment';
import {BaseLinkFragment} from '@amblique/contentful/app/contentful/fragments/link/base-link.fragment';
import {BaseShopTheLookFragment} from '@amblique/contentful/app/contentful/fragments/shop-the-look/base-shop-the-look.fragment';
import {BaseVideoFragment} from '@amblique/contentful/app/contentful/fragments/video/base-video.fragment';

export const BlogFragment = gql`
  ${BaseBlogFragment}
  ${BaseImageFragment}
  ${BaseLinkFragment}
  ${BaseShopTheLookFragment}
  ${BaseVideoFragment}

  fragment BlogFragment on Blog {
    ...BaseBlogFragment

    blogContent {
      json
      links {
        entries {
          block {
            __typename
            sys {
              id
            }
            ... on Video {
              ...BaseVideoFragment
            }
          }
        }
        assets {
          block {
            sys {
              id
            }
            contentType
            description
            fileName
            height
            width
            size
            title
            url
          }
        }
      }
    }
    shareThisPostCollection {
      items {
        __typename
        ... on Link {
          ...BaseLinkFragment
        }
      }
    }
    blogTileImage {
      __typename
      ... on Image {
        ...BaseImageFragment
      }
      ... on ShopTheLook {
        ...BaseShopTheLookFragment
      }
    }
  }
`;
